<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
  <div class="scanner-ui"></div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { IonApp, IonRouterOutlet } from "@ionic/vue";
import { Preferences } from "@capacitor/preferences";
import { StatusBar, Style } from "@capacitor/status-bar";

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
  },
  setup() {
    // const store = useStore();
    // const { scanActive, startScanner, stopScanner, prepareScanner } = useScan();
    const setStatusBarStyleLight = async () => {
      await StatusBar.setStyle({ style: Style.Light });
    };
    onMounted(async () => {
      const tempToken = await Preferences.get({ key: "accessToken" });
      //setStatusBarStyleLight();
      if (tempToken.value) {
        // await store.dispatch("user/checkAuth", tempToken.value);
        // await prepareScanner();
      } else await Preferences.remove({ key: "accessToken" });
    });
  },
});
</script>
